import React, { Component } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';

import { boards } from '../actions';

import AppList from './AppList.js';
import Dashbar from './Dashbar';
import LoadStore from './LoadStore';
import AddToBoard from './AddToBoard';
import SigninModal from './SigninModal';
import CreateModal from './CreateModal';
import CreateBanner from './CreateBanner';
import Banner from './Banner';

// const local = 'http://localhost:8000';
const prod = 'https://byteapp.herokuapp.com';
const url = prod;

class CollectionList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collections: [],
      isLoading: false,
      show: false,
      boardId: null,
      selectedApp: null,
    };
  }
  componentDidMount() {
    this.props.resetBoards();
    this.setState({ isLoading: true });
    this.setState({ collections: [] });
    axios.get(url+'/api/collections/')
    .then( res => {
      const collections = res.data;
      this.setState({ collections, isLoading: false });
    });
    window.analytics.page("View Store");

    
    this.props.fetchBoards();

    console.log('Boards:');
    console.log(this.props.boards);
  }

  addApp = (app) => {
    // console.log(app);
    this.setState({ selectedApp: app });

    this.showModal();
  }
  showModal = () => {
    this.setState({ show: true });
  };
  hideModal = () => {
    this.setState({ show: false });
  };

  handleId = e => {
    this.setState({ boardId: e.target.value });
  };
  onSubmit = e => {
    e.preventDefault();

    this.props.updateBoard(this.state.boardId, this.state.selectedApp);
    
    window.analytics.track("Added App", {
      app: this.state.selectedApp.title,
    });

    this.hideModal();
  };
  render() {
    const isLoading = this.state.isLoading;

    if (isLoading) {
      return(
        <div>
          <Dashbar/>
          <LoadStore />
        </div>
      );
    }
    if (this.props.user.username) {
      return(
        <div>
          <Dashbar/>
          <div className="collections">
            <div className="sidenav">
              {this.state.collections.map(collection =>
                <li className="items" key={collection.id}>
                  <a href={"#"+collection.slug}><h5>{collection.title}</h5></a>
                </li>
              )}
              <br/>
              <li>
                <a className="btn" href="/apps">Finish</a>
              </li>
            </div>
            <div className="cards">
              {/*this.props.boards.length === 0 ? <CreateBanner/> : null */}
              {this.state.collections.map(collection =>
                <div key={collection.id}>
                  <div className="category">
                    <div className="scrollblock" id={collection.slug}></div>
                    <h3>{collection.title}</h3>
                  </div>
                  <div className="container">
                  {collection.apps.map(app =>
                    <li key={app.id} >
                      <AppList app={app} addApp={this.addApp} />      
                    </li>
                  )}
                  </div>
                </div>  
              )}
            </div>
            {this.props.boards.length > 0 ? <AddToBoard show={this.state.show} handleClose={this.hideModal} handleId={this.handleId} onSubmit={this.onSubmit} boards={this.props.boards} /> : <CreateModal show={this.state.show} handleClose={this.hideModal} /> }
          </div>
        </div>
      );
    } else {
      return(
        <div>
          <Dashbar/>
          <div className="collections">
            <div className="sidenav">
              {this.state.collections.map(collection =>
                <li className="items" key={collection.id}>
                  <a href={"#"+collection.slug}><h5>{collection.title}</h5></a>
                </li>
              )}
            </div>
            <div className="cards">
              {/* <Banner/> */}
              {this.state.collections.map(collection =>
                <div key={collection.id}>
                  <div className="category">
                    <div className="scrollblock" id={collection.slug}></div>
                    <h3>{collection.title}</h3>
                  </div>
                  <div className="container">
                  {collection.apps.map(app =>
                    <li key={app.id} >
                      <AppList app={app} addApp={this.addApp} />      
                    </li>
                  )}
                  </div>
                </div>  
              )}
            </div>
            <SigninModal show={this.state.show} handleClose={this.hideModal} />
          </div>
        </div>
      );
    }
  }
}

const mapStateToProps = state => {
  return {
    boards: state.boards,
    user: state.auth.user,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchBoards: () => {
      dispatch(boards.fetchBoards());
    },
    resetBoards: () => {
      dispatch(boards.resetBoards());
    },
    updateBoard: (id, app) => {
      return dispatch(boards.updateBoard(id, app));
    }
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(CollectionList);


// WEBPACK FOOTER //
// ./src/components/CollectionList.js